import { BillingAddress } from './billing-address';

interface OneClickDetails {
  key: string;
  type: string;
  optional?: boolean;
}

interface OneClickPaymentMethod {
  details: OneClickDetails[];
  name: string;
  type: string;
  recurringDetailReference: string;
  storedDetails: {
    card: {
      expiryMonth: string;
      expiryYear: string;
      holderName: string;
      number: string;
    };
  };
}

interface PaymentMethod {
  brands: string[];
  details: OneClickDetails[];
  name: string;
  supportsRecurring: boolean;
  type: string;
}

export interface StoredPaymentMethods {
  /** Card on file */
  card?: StoredCardPaymentMethod;
  /** ACH/Bank info on file */
  ach?: StoredACHPaymentMethod;
}

/** Stored ACH/Bank info payment method */
export interface StoredACHPaymentMethod {
  lastFour: string;
  billing_address?: BillingAddress;
}

/** Stored credit or debit card payment method */
export interface StoredCardPaymentMethod {
  brand: string;
  expiryMonth: string;
  expiryYear: string;
  holderName: string;
  id: string;
  lastFour: string;
  name: string;
  supportedShopperInteractions: string[];
  type: string;
  billing_address?: BillingAddress;
}

/** Groups of allowed payment methods */
interface Group {
  name: string;
  types: string[];
}

export interface PaymentMethodConfiguration {
  groups: Group[];
  oneClickPaymentMethods: OneClickPaymentMethod[];
  paymentMethods: PaymentMethod[];
  storedPaymentMethods: StoredCardPaymentMethod[];
}

/** Type of payment for Adyen component */
export enum PaymentType {
  card = 'card',
  ach = 'ach',
}

export enum PaymentTitle {
  card = 'Credit or debit card',
  ach = 'Checking or Savings account',
}
